import { render, staticRenderFns } from "./UserProfileNavigation.vue?vue&type=template&id=0551aed1&scoped=true"
import script from "./UserProfileNavigation.vue?vue&type=script&lang=js"
export * from "./UserProfileNavigation.vue?vue&type=script&lang=js"
import style0 from "./UserProfileNavigation.vue?vue&type=style&index=0&id=0551aed1&prod&lang=scss"
import style1 from "./UserProfileNavigation.vue?vue&type=style&index=1&id=0551aed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551aed1",
  null
  
)

export default component.exports